import { render, staticRenderFns } from "./ManagerAddonModal.vue?vue&type=template&id=3c1471e1"
import script from "./ManagerAddonModal.vue?vue&type=script&lang=ts"
export * from "./ManagerAddonModal.vue?vue&type=script&lang=ts"
import style0 from "./ManagerAddonModal.vue?vue&type=style&index=0&id=3c1471e1&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1471e1')) {
      api.createRecord('3c1471e1', component.options)
    } else {
      api.reload('3c1471e1', component.options)
    }
    module.hot.accept("./ManagerAddonModal.vue?vue&type=template&id=3c1471e1", function () {
      api.rerender('3c1471e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/managers/ManagerAddonModal.vue"
export default component.exports